import { IClientes } from "../interfaces/IClientes";
import api from "./Api";
import Swal from 'sweetalert2';

const BASE_URL = process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3';

class ClienteService {

  async obterTodosGeral(): Promise<IClientes[]> {
    try {
      const { data: result } = await api.get<IClientes[]>('Cliente', { baseURL: BASE_URL });
      return result;
    } catch (error: any) {
      Swal.fire({ text: error.message, timer: 4000, icon: 'error', showConfirmButton: false });
      return [];
    }
  }

  async obterTodos(funcaoSucesso?: (data: IClientes[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.get<IClientes[]>('Cliente', { baseURL: BASE_URL });

      funcaoSucesso && funcaoSucesso(result);
      textoPopupSucesso && Swal.fire({ text: textoPopupSucesso, timer: 3000, icon: 'success', showConfirmButton: false });

      return true;
    } catch (error: any) {
      Swal.fire({ text: error.message, timer: 4000, icon: 'error', showConfirmButton: false });
      return false;
    }
  }

  async obterPorId(id: number, funcaoSucesso?: (data: IClientes) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.get<IClientes>(`Cliente/${id}`, { baseURL: BASE_URL });

      funcaoSucesso && funcaoSucesso(result);
      textoPopupSucesso && Swal.fire({ text: textoPopupSucesso, timer: 3000, icon: 'success', showConfirmButton: false });

      return true;
    } catch (error: any) {
      Swal.fire({ text: error.message, timer: 4000, icon: 'error', showConfirmButton: false });
      return false;
    }
  }

  async criar(parametro: IClientes, funcaoSucesso?: (data: IClientes) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.post('Cliente', parametro, { baseURL: BASE_URL });

      funcaoSucesso && funcaoSucesso(result);
      textoPopupSucesso && Swal.fire({ text: textoPopupSucesso, timer: 3000, icon: 'success', showConfirmButton: false });

      return true;
    } catch (error: any) {
      Swal.fire({ text: error.message, timer: 4000, icon: 'error', showConfirmButton: false });
      return false;
    }
  }

  async atualizar(parametro: IClientes, funcaoSucesso?: (data: IClientes) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.put(`Cliente/${parametro.id}`, parametro, { baseURL: BASE_URL });

      funcaoSucesso && funcaoSucesso(result);
      textoPopupSucesso && Swal.fire({ text: textoPopupSucesso, timer: 3000, icon: 'success', showConfirmButton: false });

      return true;
    } catch (error: any) {
      Swal.fire({ text: error.message, timer: 4000, icon: 'error', showConfirmButton: false });
      return false;
    }
  }

  async inativar(id: number, funcaoSucesso?: () => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      await api.put(`Cliente/${id}/inativar`, null, { baseURL: BASE_URL });

      funcaoSucesso && funcaoSucesso();
      textoPopupSucesso && Swal.fire({ text: textoPopupSucesso, timer: 3000, icon: 'success', showConfirmButton: false });

      return true;
    } catch (error: any) {
      Swal.fire({ text: error.message, timer: 4000, icon: 'error', showConfirmButton: false });
      return false;
    }
  }
}

export default new ClienteService();
